import { render, staticRenderFns } from "./targetPeoplePic.vue?vue&type=template&id=0ffdc480&scoped=true&"
import script from "./targetPeoplePic.vue?vue&type=script&lang=js&"
export * from "./targetPeoplePic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffdc480",
  null
  
)

export default component.exports